import { render, staticRenderFns } from "./InfoStorageMemory.vue?vue&type=template&id=418e7bb6"
import script from "./InfoStorageMemory.vue?vue&type=script&lang=ts"
export * from "./InfoStorageMemory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports